export enum SearchType {
  EVERYTHING = 'everything',
  AGENT = 'agent',
  CONCEPT = 'concept',
  TITLE = 'title',
  SERIES = 'series'
}
